// src/components/PreFooter.jsx
import { Link } from "react-router-dom";
import "../assets/styles.css";

const SOCIALS = [
  { 
    label: "Facebook", 
    href: "https://www.facebook.com/p/Piedmont-Adult-Day-Program-100064737454808/", 
    svg: (
      <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd"/>
    )
  },
  { 
    label: "LinkedIn", 
    href: "https://www.linkedin.com/company/piedmont-adult-day-program-llc/about/", 
    svg: (
      <path fillRule="evenodd" d="M20.447 20.452h-3.554v-5.569c0-1.329-.027-3.039-1.852-3.039-1.853 0-2.136 1.447-2.136 2.944v5.664H9.35V9h3.414v1.561h.047c.476-.9 1.637-1.852 3.368-1.852 3.603 0 4.267 2.372 4.267 5.458v6.285zM5.337 7.433a2.064 2.064 0 11.001-4.129 2.064 2.064 0 01-.001 4.129zM3.56 20.452h3.556V9H3.56v11.452z" clipRule="evenodd"/>
    )
  },
  { 
    label: "YouTube", 
    href: "https://www.youtube.com/channel/UCwlvTf4r-Qx4GB3caNw0AEg", 
    svg: (
      <path d="M23.498 6.186a3.003 3.003 0 00-2.116-2.127C19.6 3.5 12 3.5 12 3.5s-7.6 0-9.382.559A3.003 3.003 0 00.502 6.186C0 7.977 0 12 0 12s0 4.023.502 5.814a3.003 3.003 0 002.116 2.127C4.4 20.5 12 20.5 12 20.5s7.6 0 9.382-.559a3.003 3.003 0 002.116-2.127C24 16.023 24 12 24 12s0-4.023-.502-5.814zM9.75 15.5v-7L15.75 12l-6 3.5z"/>
    )
  },
];

const PAGES = [
  { name: "Home", to: "/" },
  { name: "Services", to: "/services" },
  { name: "About Us", to: "/about-us" },
  { name: "Our Facilities", to: "/facilities" },
  { name: "Virtual Programming", href: "https://www.youtube.com/channel/UCwlvTf4r-Qx4GB3caNw0AEg" },
];

const QUICK_LINKS = [
  { name: "Privacy Policy", to: "/privacy" },
  { name: "Terms Of Service", to: "/terms" },
  { name: "Contact Us", to: "/contact" },
];

const CONTACT = {
  addressLabel: "San Jose, CA 95132",
  mapsHref: "https://www.google.com/maps/dir/?api=1&destination=1333%20Piedmont%20Rd%20%23109%2C%20San%20Jose%2C%20CA%2095132%2C%20United%20States",
  phone: "(408) 347 - 0402",
  phoneHref: "tel:+14083470402",
  email: "padproadult@yahoo.com",
  emailHref: "mailto:padproadult@yahoo.com",
};

export default function PreFooter() {
  return (
    <footer className="relative w-full bg-[#FEF6DE] px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20">
      <div className="container mx-auto max-w-7xl">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 sm:gap-10 lg:gap-12 xl:gap-16">
          
          {/* Brand Section - Enhanced responsive design */}
          <div className="sm:col-span-2 lg:col-span-2 space-y-6 sm:space-y-8">
            <div className="space-y-2 sm:space-y-3">
              <h1 className="newsreader text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#2E7D32] leading-tight">
                PADPro
              </h1>
              <h2 className="newsreader text-lg sm:text-xl lg:text-2xl xl:text-3xl font-medium text-[#2E7D32]">
                Piedmont Adult Day Program
              </h2>
            </div>

            <p className="text-gray-800 text-sm sm:text-base lg:text-lg xl:text-xl leading-relaxed newsreader max-w-lg lg:max-w-2xl">
              philosophy hinges on Self-Help Advocacy through Responsive Programming (S.H.A.R.P) using a Person-Centered Approach.
            </p>

            {/* Social Media Links */}
            <div className="flex items-center gap-3 sm:gap-4">
              {SOCIALS.map(({ label, href, svg }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Follow us on ${label}`}
                  className="text-gray-800 hover:text-[#2E7D32] transition-all duration-300 hover:scale-110 p-1"
                >
                  <svg className="h-7 w-7 sm:h-8 sm:w-8 lg:h-9 lg:w-9" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    {svg}
                  </svg>
                </a>
              ))}
            </div>
          </div>

          {/* Pages Navigation */}
          <nav className="space-y-4 sm:space-y-6">
            <h3 className="font-semibold text-gray-900 text-base sm:text-lg lg:text-xl">
              Pages
            </h3>
            <ul className="space-y-3 sm:space-y-4">
              {PAGES.map((item) =>
                item.href ? (
                  <li key={item.name}>
                    <a
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-700 hover:text-gray-900 transition-colors duration-300 text-sm sm:text-base flex items-center group"
                    >
                      <span>{item.name}</span>
                      <svg className="w-3 h-3 ml-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                    </a>
                  </li>
                ) : (
                  <li key={item.name}>
                    <Link 
                      to={item.to} 
                      className="text-gray-700 hover:text-gray-900 transition-colors duration-300 text-sm sm:text-base hover:underline underline-offset-2"
                    >
                      {item.name}
                    </Link>
                  </li>
                )
              )}
            </ul>
          </nav>

          {/* Quick Links Navigation */}
          <nav className="space-y-4 sm:space-y-6">
            <h3 className="font-semibold text-gray-900 text-base sm:text-lg lg:text-xl">
              Quick Links
            </h3>
            <ul className="space-y-3 sm:space-y-4">
              {QUICK_LINKS.map(({ name, to }) => (
                <li key={name}>
                  <Link 
                    to={to} 
                    className="text-gray-700 hover:text-gray-900 transition-colors duration-300 text-sm sm:text-base hover:underline underline-offset-2"
                  >
                    {name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Contact Details */}
          <div className="space-y-4 sm:space-y-6 sm:col-span-2 lg:col-span-1">
            <h3 className="font-semibold text-gray-900 text-base sm:text-lg lg:text-xl">
              Contact Details
            </h3>
            <ul className="space-y-4 sm:space-y-5 text-gray-700">
              
              {/* Address */}
              <li className="flex items-start gap-3">
                <svg className="w-5 h-5 sm:w-6 sm:h-6 text-red-500 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                </svg>
                <a 
                  href={CONTACT.mapsHref} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:text-gray-900 transition-colors duration-300 text-sm sm:text-base hover:underline underline-offset-2"
                >
                  {CONTACT.addressLabel}
                </a>
              </li>

              {/* Phone */}
              <li className="flex items-center gap-3">
                <svg className="w-5 h-5 sm:w-6 sm:h-6 text-red-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                <a 
                  href={CONTACT.phoneHref} 
                  className="hover:text-gray-900 transition-colors duration-300 text-sm sm:text-base hover:underline underline-offset-2"
                >
                  {CONTACT.phone}
                </a>
              </li>

              {/* Email */}
              <li className="flex items-start gap-3">
                <svg className="w-5 h-5 sm:w-6 sm:h-6 text-red-500 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                <a 
                  href={CONTACT.emailHref} 
                  className="hover:text-gray-900 transition-colors duration-300 text-sm sm:text-base hover:underline underline-offset-2"
                >
                  {CONTACT.email}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}